<template>
  <label
    class="tw:inline-block tw:select-none tw:m-0!"
    :class="{ 'tw:opacity-60 tw:cursor-not-allowed': disabled }"
    role="switch"
    @click.prevent="toggle"
  >
    <input
      v-if="name"
      type="checkbox"
      :name="name"
      :checked="isChecked"
      class="tw:hidden"
      :disabled="disabled"
      @change.stop="toggle"
    />

    <span
      class="tw:relative tw:inline-block tw:align-middle tw:w-12 tw:h-6 tw:rounded-full tw:transition-colors tw:duration-300 tw:ease-in-out"
      :class="isChecked ? 'tw:bg-(--maincolor)' : 'tw:bg-(--bordercolor)'"
    >
      <span
        class="tw:absolute tw:top-1 tw:left-1 tw:w-4 tw:h-4 tw:bg-white tw:rounded-full tw:transform tw:transition-transform tw:duration-300 tw:ease-in-out"
        :class="isChecked ? 'tw:translate-x-6' : 'tw:translate-x-0'"
      ></span>
    </span>
  </label>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

interface Props {
  modelValue?: boolean
  sync?: boolean               // mantém comportamento antigo
  disabled?: boolean
  name?: string
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: undefined,
  sync: false,
  disabled: false,
  name: undefined,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'change', value: boolean): void
}>()

const isChecked = computed({
  get() {
    return props.modelValue
  },
  set(val: boolean) {
    emit('update:modelValue', val)
  }
})

// ------------------------------
// TOGGLE
// ------------------------------
function toggle() {
  if (props.disabled) return

  const newVal = !isChecked.value
  isChecked.value = newVal
  emit('change', newVal)
}

</script>
